<div class="breadCrumb-container flex flex-wrap items-center text-sm overflow-hidden ">

    <a (click)="redirect('/home',0)" matTooltip="Home">
      <div id="home" class="flex text-text  font-semibold cursor-pointer my-auto">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"
          class="w-5 h-5">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M5 12l-2 0l9 -9l9 9l-2 0" />
          <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" />
          <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" />
        </svg>
      </div>
    </a>

  <span *ngIf="firstLoad" class=" text-gray-600 ">
    <svg class="w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M9 5l7 7-7 7" />
    </svg>
  </span>

  <div class="flex-row  justify-between flex align-middle "
    *ngFor="let u of urls; last as last; first as first; index as index">
  
      <a (click)="redirect(u,index)" [matTooltip]="u">
        <!--<div class="flex" *ngIf="first"><i class="e-icons"></i></div>-->
        <div *ngIf="u!='home' && !first " [id]="u+'id'" class="flex text-text text-xs font-semibold cursor-pointer">
          {{u}}</div>
        <div *ngIf="!first && index>1 && u=='home'" [id]="u+'id'" class="flex text-text text-xs font-semibold cursor-pointer">
          {{u}}</div>
      </a>
  
    <span *ngIf="index>0 && !last" class=" text-gray-600 ">
      <svg class="w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M9 5l7 7-7 7" />
      </svg>
    </span>
  </div>
</div>